module.exports = __webpack_public_path__ + "img/CoFundedNorwegian.e3acfda6.png";